import type React from "react";
interface ToggleProps {
	enabled: boolean;
	onChange: () => void;
	disabled?: boolean;
}
export const Toggle: React.FC<ToggleProps> = ({ enabled, onChange, disabled = false }) => {
	return (
		<button
			type="button"
			role="switch"
			aria-roledescription="Toggle switch"
			aria-checked="mixed"
			disabled={disabled}
			className={`${enabled ? "bg-green-400" : "bg-gray-200"} relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
			onClick={onChange}
		>
			<span className="sr-only">Toggle setting</span>
			<span
				className={`${enabled ? "translate-x-5" : "translate-x-0"} pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}
			>
				<span
					className={`${enabled ? "opacity-0 duration-100 ease-out" : "opacity-100 duration-200 ease-in"} absolute inset-0 flex h-full w-full items-center justify-center transition-opacity`}
					aria-hidden="true"
				/>
				<span
					className={`${enabled ? "opacity-100 duration-200 ease-in" : "opacity-0 duration-100 ease-out"} absolute inset-0 flex h-full w-full items-center justify-center transition-opacity`}
					aria-hidden="true"
				/>
			</span>
		</button>
	);
};
